import { apiUrl, authHeaders } from "./httpAuth";

export async function fetchTipoArmas() {
    const res = await fetch(apiUrl("api/enums/tipo-armas"), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}
